import { render, staticRenderFns } from "./cutBar.md?vue&type=template&id=621a3bae&"
import script from "./cutBar.md?vue&type=script&lang=js&"
export * from "./cutBar.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('621a3bae')) {
      api.createRecord('621a3bae', component.options)
    } else {
      api.reload('621a3bae', component.options)
    }
    module.hot.accept("./cutBar.md?vue&type=template&id=621a3bae&", function () {
      api.rerender('621a3bae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/more/bar/cutBar.md"
export default component.exports